export function stripContentTypeParameters(mediaType) {
  return (mediaType === null || mediaType === void 0 ? void 0 : mediaType.split(';').shift()) || '';
}